import { ColorRGBA } from 'q-floodfill';

export interface IReplaceColor {
  colorToReplace: ColorRGBA;
  colorToReplaceWith: ColorRGBA;
}

const replaceColorsWithWorker = async (canvas: HTMLCanvasElement, colors: IReplaceColor[]) => {
  return new Promise((resolve) => {
    const ctx = canvas.getContext('2d', { alpha: false });
    if (!ctx) return;
    const { width, height } = canvas;
    const imgData = ctx.getImageData(0, 0, width, height);
    const worker = new Worker(new URL('./replaceColorsWorker.ts', import.meta.url));
    worker.postMessage({ imageData: imgData, colors, width, height });
    worker.onmessage = (event) => {
      const { imageData } = event.data;
      ctx.putImageData(imageData, 0, 0);
      resolve(imageData);
      worker.terminate();
    };
  });
};

export default replaceColorsWithWorker;
